import React from 'react';
import '../../styles/spinner.css';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="spinner-ring"></div>
      <p className="spinner-text">{message}</p>
    </div>
  );
};

export default LoadingSpinner;